<template>
  <v-autocomplete
    v-model="member"
    :items="memberOptions"
    :loading="isLoading"
    :search-input.sync="search"
    @focus="searching"
    @resetMember="resetMember"
    hide-no-data
    persistent-hint
    auto-select-first
    :item-text="(item) => item.Tag"
    item-value="ID"
    :label="label"
    :prepend-icon="mdiDatabaseSearch"
    return-object
    no-filter
    :error-messages="errorMessages"
    clearable
    v-on:click:clear="clear"
    v-on:change="change"
    hide-details
    dense
    :inputmode="inputmode"
  >
    <template v-slot:item="{ item }">
      <v-list-item-avatar
        color="secondary"
        class="text-h5 font-weight-light white--text"
      >
        {{ item.Tag.charAt(0) }}
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="item.Tag"></v-list-item-title>
        <v-list-item-subtitle v-text="item.Address"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mdiDatabaseSearch } from "@mdi/js";
import debounce from "lodash/debounce";
import { GetMemberAdd, GetDefaultMemberAdd } from "@/api/publicServices";
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    cachedMembers: {
      type: Array,
    },
    errorMessages: {
      type: String,
    },
    onChange: {
      type: Function,
    },
  },
  data: () => ({
    memberOptions: [
      {
        ID: "",
        ShortCode: 0,
        Tag: "",
        Address: "",
      },
    ],
    isLoading: false,
    search: null,
    member: {
      ID: "",
      ShortCode: "",
      Tag: "",
      Address: "",
    },
    isClear: false,

    //svg icons
    mdiDatabaseSearch,
  }),
  created: function () {
    this.debouncedSearchMember = debounce(this.searchMember, 500);
  },
  computed: {
    inputmode() {
      return localStorage.getItem("flutter") == "true"  || this.$isMobile()? "text" : "none";
    },
  },
  methods: {
    async searchMember(searchVal) {
      try {
        console.log(`searchVal:${searchVal} isClear:${this.isClear}`);
        if (this.isClear) {
          this.isClear = false;
          return;
        }
        if (this.isLoading) return;
        this.isLoading = true;
        const response = await GetMemberAdd({ SearchVal: searchVal });
        console.log(`response:${response}`);
        this.memberOptions = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async setDefault() {
      try {
        this.isLoading = true;
        const response = await GetDefaultMemberAdd({});
        this.isLoading = false;
        console.log(response.data);
        if (response.data) {
          this.memberOptions.push(response.data);
          this.member = {
            ID: response.data.ID,
            Tag: response.data.Tag,
            Address: response.data.Address,
          };
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async searching(t1) {
      this.searchMember(t1.target.value);
    },
    resetMember() {
      this.member = {};
      this.member.ID = "";
      this.member.Tag = "";
      this.member.Address = "";
    },
    clear() {
      this.isClear = true;
      console.log("clear");
    },
    change() {
      console.log("change");
    },
  },
  watch: {
    search(newVal) {
      this.debouncedSearchMember(newVal);
    },
    member() {
      this.$emit("input", this.member);
      if (this.$refs.MemberAddress) {
        this.$refs.MemberAddress = this.member.Address;
      }
    },
  },
};
</script>
